<template>
  <div class="card" style="border-radius: 5px; width: 800px; height: 540px;">
    <div>
      <header class="modal-card-head" >


        <div class="modal-card-title">
          <img class="infoa is-pulled-left mr-3" style="border-radius: 3px; height: 50px;" :src="location.logo">

        <h1 class="is-size-4 mb-2">{{ location.name }}</h1>
        <h2 class="is-size-6 has-text-grey">
          {{ location.address }}
        </h2>
        </div>



        <button
            type="button"
            class="delete"
            @click="$emit('close')"/>
    </header>
      <div class="columns is-hidden-touch mt-2">
        <div class="column is-narrow">
        <HourSchedule class="m-4" style="margin: auto; width: 250px;" :hours="location.hours" :name="location.name"
              :address="location.address" :logo="location.logo"></HourSchedule>
      </div>
        <div class="column">
        <GMap class="m-4" :lat="location.position.lat" :long="location.position.lng" carOrHotel="car" width="450" height="375"/>
      </div>
      </div>
      <b-tabs position="is-centered" class="block is-hidden-desktop" v-model="activeTab" style="margin-bottom: 0px; padding-bottom: 0px;">
        <b-tab-item label="Hours">
          <HourSchedule style="margin: auto;" :hours="location.hours" :name="location.name"
                  :address="location.address" :logo="location.logo"></HourSchedule>
        </b-tab-item>
        <b-tab-item class="mobile-margins container" label="Map">
          <GMap  style="margin-left: -1rem !important;" :lat="location.position.lat" :long="location.position.lng" carOrHotel="car"/>
        </b-tab-item>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import GMap from '../../GMap/GMap.vue'
import HourSchedule from './HourSchedule.vue'
import bookingMixin from "@/mixins/bookingMixin";

    export default {
      name: 'CarDetails',
      mixins: [bookingMixin],
      components: {
        GMap,
        HourSchedule
      },
    props: {
        location: Object
      },
    data: function () {
          return {
            loading: true,
            description: {},
            activeTab: 0,
            cardConversions: {

            }
        }
      },
    computed: {
    },
    methods: {
    },
    mounted () {
    },
  }

</script>

<style scoped>
</style>
